import EntryProxy from '@/app/proxies/EntryProxy';

export default {
    namespaced: true,

    state: {
        entry: null
    },

    getters: {
        get: state => state.entry
    },

    mutations: {
        savedEntry: ( state, payload ) =>
        {
            state.entry = payload;
        }
    },

    actions: {
        save( context, payload )
        {
            return new EntryProxy()
                .create( payload )
                .then( ( response ) =>
                {
                    let entry = Object.assign( payload, response );
                    context.commit( 'savedEntry', entry );
                    return response;
                })
                .catch( ( error ) =>
                {
                    return Promise.reject( error );
                });
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/store/modules/entry.js